import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export default function getMarkCompleteTasksReducer(state = initialState.markCompleteTasks, action) {
	switch (action.type) {
		case types.GET_MARK_COMPLETE_TASKS: {
			if (action.response) {
				return {
					...state,
					[action.apiKey]:
						action.response?.taskGroups && action.response.taskGroups[0] && action.response?.taskGroups[0]?.tasks
				};
			}
			return state;
		}
		case types.CLEAR_MARK_COMPLETE_TASKS: {
			return {};
		}
		default:
			return state;
	}
}
